<template>
	<Card>
		<div class="container-fluid" style="min-height: 600px;">
			<div class="row pt-3">
				<div class="col-sm-12">
					<h5 class="back-title" @click="back()"><i class="fa fa-angle-left"></i> Back To Admin </h5>
				</div>
				<div class="col-sm-12">
					<div class="row pt-3  pl-3 pr-3">
						<div class="col-sm-12">
							<span class="rate-title">Rates for {{ user.site }}</span>
						</div>
					</div>
					<div class="row pt-3 pb-3  pl-3 pr-3" v-if="!!rates && rates.length > 0">
						<div class="col-sm-12 d-flex input-group" v-for="rate in rates">
							<div class="input-wrapper pr-1">
								<label for="effective-from">Effective from:</label>
								<span id="effective-from" class="d-block"> 
									{{ new Date(rate.effectDate).toISOString() }} 
								</span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="apply-to">Apply to</label>
								<span class="d-block"> {{ rate.apply }}</span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="standing-charge">Standing Charge</label>
								<span id="standing-charge" class="d-block"> {{ rate.standing_charge }}</span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="supplier">Supplier</label>
								<span id="supplier" class="d-block"> {{ rate.supplier }} </span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="supplier">Start Time</label>
								<span id="supplier" class="d-block"> {{ rate.startTime }} </span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="supplier">End Time</label>
								<span id="supplier" class="d-block"> {{ rate.endTime }} </span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="rate1">Day Rate:</label>
								<span id="rate1" class="d-block"> {{ rate.cost_1 }} </span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="rate2">Night Rate:</label>
								<span id="rate2" class="d-block"> {{ rate.cost_2 }} </span>
							</div>
							<div class="input-wrapper pr-1">
								<label for="rate3">Gen Rate:</label>
								<span id="rate3" class="d-block"> {{ rate.cost_3 }} </span>
							</div>
							<div class="input-wrapper">
								<label for="rate4">Rate:</label>
								<span id="rate4" class="d-block"> {{ rate.cost_4 }} </span>
							</div>
							<div class="input-wrapper mt-2 d-flex">
								<button type="button" class="update-button d-block h-full mr-2" @click="editRate(rate)">
									Update Rates
								</button>
								<button type="button" class="update-button d-block h-full" @click="removeRates(rate.id)">
									Delete Rates
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row pl-4" v-if="!!isAdd">
				<div class="row pt-3 pb-3  pl-3 pr-3">
					<div class="col-sm-12 d-flex input-group">
						<div class="input-wrapper">
							<label for="effective-from">Effective from:</label>
							<date-picker id="effective-from" class="inline-block h-full"  :attributes ="attrs" v-model="changeRate.effectDate">
								<template v-slot="{ inputValue, togglePopover }">
									<div class="d-flex items-center"  style="display:flex;">
										<button
											class="timepickerbutton"
											@click="togglePopover()"
										>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
												<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
											</svg>
										</button>
										<input
											:value="inputValue"
											class="display-time"
											readonly
										/>
									</div>
								</template>
							</date-picker>
						</div>
						<div class="input-wrapper">
							<label for="apply-to">Apply to</label>
							<select id="apply-to" class="d-block h-full" v-model="changeRate.apply">
								<option v-for="device in devices" :value="device.value">{{ device.label }}</option>
							</select>
						</div>
						<div class="input-wrapper">
							<label for="standing-charge">Standing Charge</label>
							<input id="standing-charge" type="text" class="rate-input d-block h-full" v-model="changeRate.standing_charge"/>
						</div>
						<div class="input-wrapper">
							<label for="supplier">Supplier</label>
							<input id="supplier" type="text" class="rate-input d-block h-full" v-model="changeRate.supplier"/>
						</div>
						<div class="input-wrapper">
							<label for="starttime">Start Time</label>
							<select id="starttime" class="d-block h-full" v-model="changeRate.startTime">
								<option v-for="time in times" :value="time.value">{{ time.label }}</option>
							</select>
						</div>
						<div class="input-wrapper">
							<label for="endtime">End Time</label>
							<select id="endtime" class="d-block h-full" v-model="changeRate.endTime">
								<option v-for="time in times" :value="time.value">{{ time.label }}</option>
							</select>
						</div>
						<div class="input-wrapper">
							<label for="rate1">Rate 1:</label>
							<input id="rate1" type="text" class="rate-input d-block h-full" v-model="changeRate.cost_1"/>
						</div>
						<div class="input-wrapper">
							<label for="rate2">Rate 2:</label>
							<input id="rate2" type="text" class="rate-input d-block h-full" v-model="changeRate.cost_2"/>
						</div>
						<div class="input-wrapper">
							<label for="rate3">Rate 3:</label>
							<input id="rate3" type="text" class="rate-input d-block h-full" v-model="changeRate.cost_3"/>
						</div>
						<div class="input-wrapper">
							<label for="rate4">Rate 4:</label>
							<input id="rate4" type="text" class="rate-input d-block h-full" v-model="changeRate.cost_4"/>
						</div>
						<div class="input-wrapper mt-2 d-flex">
							<button 
								id="update"
								type="button"
								class="update-button d-block h-full mr-2"
								@click="saveRates()"
								v-if="!isEdit">
								Create Rates
							</button>
							<button
								id="update"
								type="button"
								class="update-button d-block h-full mr-2"
								@click="saveRates()"
								v-if="!!isEdit">
								Update Rates
							</button>
							<button id="update" type="button" class="update-button d-block h-full" @click="isAdd=false">
								Cancel
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="row pl-5"  v-if="showError">
				<div class="form-group mt-1 mb-1 justify-content-center">
					<p class="error-message" v-for="message in messages">
						<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ message }}
					</p>
				</div>
			</div>
			<div class="row pl-4 pb-5 mt-5">
				<div class="col-sm-12">
					<button type="button" class="update-button" @click="addRate()">
						<i class="fa fa-plus"></i>
						Add rate period
					</button>
				</div>
			</div>
		</div>
	</Card>
</template>

<script>
import Card from "@/components/Cards/Card";
import { mapActions, mapGetters } from "vuex";
export default {
	name: 'Rates',
	components: {
		Card
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser'
		})
	},
	data() {
		return {
			isAdd: false,
			isEdit: false,
			changeRate: null,
			applyTo: null,
			showError: false,
			messages: [],
			attrs: [
				{
					key: 'today',
    				highlight: true,
					dates: new Date(),
				}
			],
			devices: [
				{label:'Electricity', value: 'Electricity'},
				{label:'Water', value: 'Water'},
				{label:'Gas', value: 'Gas'},
			],
			times: [
				{ label: '00:00', value: 0},
				{ label: '00:30', value: 0.5},
				{ label: '01:00', value: 1},
				{ label: '01:30', value: 1.5},
				{ label: '02:00', value: 2},
				{ label: '02:30', value: 2.5},
				{ label: '03:00', value: 3},
				{ label: '03:30', value: 3.5},
				{ label: '04:00', value: 4},
				{ label: '04:30', value: 4.5},
				{ label: '05:00', value: 5},
				{ label: '05:30', value: 5.5},
				{ label: '06:00', value: 6},
				{ label: '06:30', value: 6.5},
				{ label: '07:00', value: 7},
				{ label: '07:30', value: 7.5},
				{ label: '08:00', value: 8},
				{ label: '08:30', value: 8.5},
				{ label: '09:00', value: 9},
				{ label: '09:30', value: 9.5},
				{ label: '10:00', value: 10},
				{ label: '10:30', value: 10.5},
				{ label: '11:00', value: 11},
				{ label: '11:30', value: 11.5},
				{ label: '12:00', value: 12},
				{ label: '12:30', value: 12.5},
				{ label: '13:00', value: 13},
				{ label: '13:30', value: 13.5},
				{ label: '14:00', value: 14},
				{ label: '14:30', value: 14.5},
				{ label: '15:00', value: 15},
				{ label: '15:30', value: 15.5},
				{ label: '16:00', value: 16},
				{ label: '16:30', value: 16.5},
				{ label: '17:00', value: 17},
				{ label: '17:30', value: 17.5},
				{ label: '18:00', value: 18},
				{ label: '18:30', value: 18.5},
				{ label: '19:00', value: 19},
				{ label: '19:30', value: 19.5},
				{ label: '20:00', value: 20},
				{ label: '20:30', value: 20.5},
				{ label: '21:00', value: 21},
				{ label: '21:30', value: 21.5},
				{ label: '22:00', value: 22},
				{ label: '22:30', value: 22.5},
				{ label: '23:00', value: 23},
				{ label: '23:30', value: 23.5},

			],
			rates: [],
			shortMonthNames: [
				'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
			],
		}
	},
	async created() {
		this.rates = await this.getRates(this.user.siteId);
		console.log(this.rates);
	},
	methods: {
		...mapActions({
			getChannels: "admin/getChannels",
			getRates: "admin/getRates",
			addRates: "admin/addRates",
			deleteRate: "admin/deleteRate",
			setUserSite: "auth/setUserSites"
		}),
		editRate(rate) {
			this.isAdd = true
			this.isEdit = true;
			this.changeRate = rate;
		},
		back() {
			this.$router.push({name: 'admin'});
		},
		addRate() {
			this.isAdd = true;
			this.changeRate = {
				effectDate: null,
				cost_1: 0,
				cost_2: 0,
				cost_3: 0,
				cost_4: 0,
				supplier: '',
				standard_charge: 0,
			}
		},
		async removeRates(id) {
			const res = await this.deleteRate(id);
			let _index;
			this.rates.forEach((item, index) => {
				if (item.id === id) _index = index;
			});
			this.rates.splice(_index, 1);
			this.$toasted.show("Rates is deleted successfully", {
				type: "success",
				duration: 2500,
			});
		},
		async saveRates() {
			this.messages = [];
			console.log(this.user)


			if (!this.changeRate.effectDate) {
				this.messages.push('Effective From is required');
			}

			if (!this.changeRate.apply) {
				this.messages.push('Apply is required');
			}

			if (!this.changeRate.cost_1) {
				this.messages.push('Day rate is required');
			}

			if (!this.changeRate.cost_2) {
				this.messages.push('Night rate is required');
			}

			if (!this.changeRate.hasOwnProperty('startTime')) {
				this.messages.push('Start time is required');
			}

			if (!this.changeRate.hasOwnProperty('endTime')) {
				this.messages.push('End time is required');
			}
			
			if (this.messages.length === 0) {
				this.showError = false;
			} else {
				this.showError = true;
			}

			if (!this.showError) {
				this.isEdit = false;
				this.isAdd = false;
				const rate = await this.addRates(this.changeRate);
				if (this.changeRate.id) {
					this.$toasted.show("Rates is updated successfully", {
						type: "success",
						duration: 2500,
					});
				} else {
					this.$toasted.show("Rates is add successfully", {
						type: "success",
						duration: 2500,
					});
				}
				let site = {
					id: this.user.siteId,
					userId: this.user.id,
					name: this.user.site
				}
				await this.setUserSite(site)
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.rate-name {
	font-size: 16px;
	font-family: "Nunito Sans Light";
	font-weight: 100;
	padding-top: 5px;
}
.rate-title {
	font-size: 18px;
	font-weight: 300;
	font-family: "Nunito Sans Regular";
}
.back-title {
	color: #4fcf8d;
	cursor: pointer;

	&:hover {
		color: #4fcf00;
		opacity: 0.8;
	}
}
.rate-input {
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
}
.description-title {
	font-weight: 100;
	font-family: "Nunito Sans Light";
}

.display-time {
	width: 120px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
}

.timepickerbutton {
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
}

#apply-to, #starttime, #endtime {
	width: 120px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	z-index: 8;
	font-size: 14px;
	font-family: 'Nunito Sans Light';
	&:hover {
		background-color: #1f5881;
	}
}
#standing-charge {
	width: 100px;
}
#supplier {
	width: 100px;
}
#rate1 {
	width: 80px;
	background: darkgreen;
}
#rate2 {
	width: 80px;
	background: yellowgreen;
}
#rate3 {
	width: 80px;
	background: cornflowerblue;
}
#rate4 {
	width: 80px;
	background: rebeccapurple;
}
.update-button {
	width: 140px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;

	&:hover {
		background: #172d5b;
	}
}

.input-group {
	label {
		font-family: "Nunito Sans Light";
		font-size: 13px;
		font-weight: 100;
		color: white;
	}
}
</style>
